export interface CapabilityItem {
  id: "sales-lead-capture" | "internal-information-delivery" | "product-support" | "voice-experiences";
  name: string;
  tagline: string;
  href: string;
}

export const capabilityItems: CapabilityItem[] = [
  {
    id: "sales-lead-capture",
    name: "Sales & Lead Capture",
    tagline: "Qualify leads, answer sales questions, and book meetings, 24/7.",
    href: "/capabilities/sales-lead-capture",
  },
  {
    id: "internal-information-delivery",
    name: "Internal Information Delivery",
    tagline: "Give your team instant voice access to company knowledge and SOPs.",
    href: "/capabilities/internal-information-delivery",
  },
  {
    id: "product-support",
    name: "Product Support",
    tagline: "Answer product questions, troubleshoot issues, and reduce tickets.",
    href: "/capabilities/product-support",
  },
  {
    id: "voice-experiences",
    name: "Voice Experiences",
    tagline: "Create unique branded voice experiences for customers, teams, and stakeholders.",
    href: "/capabilities/voice-experiences",
  },
];
